
import React, {Component} from 'react'
import {Button, Modal, ModalHeader, ModalBody} from "reactstrap";
import InputTextComponent from "../../components/forms/InputTextComponent";

const translator = require("../../utils/translator/translator");
var stateManager = require('../../utils/state/stateManager.js');
var stringUtil = require('../../utils/string/stringUtil');
var navigationDialogueAction = require('../../utils/state/actions/views/navigationDialogue/navigationDialogueAction');
var storefrontUtility = require('../../utils/domain/storefrontUtility');
var constants = require('../../utils/domain/constants');
var saleInitializer = require('../../utils/domain/sales/saleInitializer');
var saleContextUtil = require('../Order/utils/saleContextUtil');

class PagerNumberView extends Component 
{
    constructor(props)
    {
        super(props);

        this.state = {};
        this.state.pagerNumber = "";
        this.state.error = "";
        this.state.sale = null;
        this.state.originalSaleNumber = "";

        if (this.props.sale != null)
        {
            this.state.sale = this.props.sale;

            let originalSaleNumber = this.state.sale.number.split("/");
            if (originalSaleNumber.length == 2)
            {
                this.state.originalSaleNumber = stringUtil.trimString(originalSaleNumber[1]);
                this.state.pagerNumber = stringUtil.trimString(originalSaleNumber[0]);
            }
            else
            {
                this.state.originalSaleNumber = stringUtil.trimString(originalSaleNumber[0]);
            }
        }

        this.handleModalOpen = this.handleModalOpen.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this)

        this.inputFieldRef = React.createRef();
    }

    handleModalOpen()
    {
        this.inputFieldRef.current.focus();
    }

    handleCancel()
    {
        if (this.props.onCancel != null)
        {
            this.props.onCancel();
        }
        else
        {
            stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
        }

    }

    handleOk()
    {
        if (stringUtil.isStringNullOrEmpty(this.state.pagerNumber))
        {
            const storefrontOperatingConfiguration = storefrontUtility.getCurrentStorefront().operatingConfiguration;
            if(storefrontOperatingConfiguration.takeAwayRequiresOrderReference == constants.triStateFlag.always)
            {
                this.state.error = translator.getLabel("pager_number_cannot_be_left_empty"); 
                this.setState({});
                return;
            }
        }

        if (this.state.sale == null)
        {
            let sale = saleInitializer.createNewSale(storefrontUtility.getCurrentStorefrontVenueCode(), constants.DispatchTypeTakeAway, storefrontUtility.getCurrentStorefront().id);
            let saleContext = saleContextUtil.instantiateSaleContext(sale, false);
            if (!stringUtil.isStringNullOrEmpty(this.state.pagerNumber))
                sale.number = `${this.state.pagerNumber} / ${sale.number}`;

            stateManager.getStore().dispatch(navigationDialogueAction.createAction(null));
            saleContextUtil.openSaleContext(saleContext);
        }
        else
        {
            this.state.sale.number = this.state.originalSaleNumber;
            if (!stringUtil.isStringNullOrEmpty(this.state.pagerNumber))
                this.state.sale.number = `${this.state.pagerNumber} / ${this.state.sale.number}`;

            saleContextUtil.raiseSaleContextSaleChangeEvent(false);
            this.props.onDone();
        }
    }

    render()
    {
        return (
            <Modal isOpen={true} backdrop={true} animation={false} fade={false}
                   onOpened={this.handleModalOpen} size="lg">
                <ModalHeader
                    close={
                        <div>
                            <Button className="btn-cancel" onClick={this.handleCancel}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                            <Button className="btn-ok" onClick={this.handleOk}>{translator.getLabel("done")}</Button>
                        </div>
                    }
                >
                    <span className="window-title">{translator.getLabel("pager_number")}</span>
                </ModalHeader>
                <ModalBody>
                    <InputTextComponent
                            placeholder={translator.getLabel("pager_number")}
                            autoComplete="off" 
                            value={this.state.pagerNumber} 
                            onValueChange={(value) => {this.state.pagerNumber = value; this.setState({}) }}
                            inputTextType="text"
                            internalRef={this.inputFieldRef}
                            error={this.state.error}
                        />
                </ModalBody>
            </Modal>
        );
    }
}

export default PagerNumberView